export default "__VITE_ASSET__0GfvBRCq__"